import React, { FC } from 'react';
import s from './Footer.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import cs from 'classnames';
import { useEditUrl } from '../../hooks/useEditUrl';
import { useInitialState } from '../../contexts/InitialStateContext';
import { footerDataHooks } from './Footer.dataHooks';
import { BLANK_TEMPLATE_META_SITE_ID, JOIN_WAIT_LIST_URL } from '../../config';
import { useBiLogger } from '../../contexts/BILoggerContext';

export const Footer: FC = () => {
  const { userData } = useInitialState();
  const biLogger = useBiLogger();
  const editUrl = useEditUrl({ metaSiteId: BLANK_TEMPLATE_META_SITE_ID });

  const isNotStudioUser =
    !userData.isLoggedIn || !userData.profile.isStudioAccount;
  const postfix = isNotStudioUser ? '.notStudioUser' : '';

  const url = isNotStudioUser ? JOIN_WAIT_LIST_URL : editUrl;
  const urlTarget = isNotStudioUser ? '_blank' : '_self';

  const onClick = () => {
    if (isNotStudioUser) {
      biLogger.reportJoinTheWaitlistClick(false);
    } else {
      biLogger.reportStartFromBlankClick(false);
    }
  };

  const { t } = useTranslation();
  return (
    <footer className={s.footer}>
      <section className={cs(s.titleSection, s.section)}>
        <div className={s.goToIcon}>
          <div className={s.circle}></div>
        </div>
        <div data-hook={footerDataHooks.title()} className={s.titleText}>
          {t(`app.footer.title${postfix}`)}
        </div>
      </section>
      <section className={cs(s.subtitleSection, s.section)}>
        <a
          data-hook={footerDataHooks.subtitle()}
          href={url}
          className={s.subtitleText}
          target={urlTarget}
          onClick={onClick}
        >
          {t(`app.footer.sub-title${postfix}`)}
          <span className={s.goToArrow}>↳</span>
        </a>
        <a
          data-hook={footerDataHooks.actionButton()}
          href={url}
          className={s.goToIcon}
          onClick={onClick}
          target={urlTarget}
        >
          <div className={s.circle}>
            <div className={s.goToArrow}>↳</div>
          </div>
        </a>
      </section>
    </footer>
  );
};
